import { toInt } from './conversion';

export function getElementKey(node: Element): string | undefined {
    var key = node.getAttribute("data-key");
    return key ? key : undefined;
}
export function getElementIndex(node: Element): number | undefined {
    var result: number = parseFloat(node.getAttribute("data-index") as string);
    if (isNaN(result)) result = -1;
    return result;
}

export function closest(el: any, selector: string): Element | undefined {
    while (el) {
        if (isSelectorMatch(el, selector)) {
            return el;
        }
        el = el.parentElement;
    }
    return undefined;
}

// look through parents for element with specified key
export function closestByKey(el: any, key: string): Element | undefined {
    while (el) {
        if (getElementKey(el) === key) return el;
        el = el.parentElement;
    }
    return undefined;
}

export function closestKey(el: any, selector: string): string | undefined {
    const tmp = closest(el, selector);
    if (!tmp) return undefined;
    return getElementKey(tmp);
}
export function closestKeyAsInt(el: any, selector: string): number {
    return toInt(closestKey(el, selector));
}

export function closestIndex(el: any, selector: string): number {
    const found = closest(el, selector);
    if (found) {
        const result = getElementIndex(found);
        return (result! >= 0) ? result! : -1;
    } else {
        return -1;
    }
}

//NOTE: this is just built for checking single class names at moment
export function isSelectorMatch(el: any, selector: string): boolean {
    if (!el || !el.classList) return false;

    if ((selector as any).startsWith(".")) {
        return el.classList.contains(selector.substring(1));
    } else {
        if (el.tagName.toLowerCase() === selector) {
            return true;
        }
    }

    return false;
}

export function getFirstByClassName(className: string) {
    const els = document.getElementsByClassName(className);
    if (els.length > 0) return els[0] as HTMLElement;
    return null;
}

export function getFirstChildByClassName(el: Element, className: string) {
	if (className.startsWith(".")) className = className.substr(1);

    const els = el.getElementsByClassName(className);
    if (els.length > 0) return els[0] as HTMLElement;
    return null;
}

export function isVisible(el: HTMLElement) {
    // taken from jQuery
    if (!el) return false;
    return !!( el.offsetWidth || el.offsetHeight || el.getClientRects().length );
};


export function getImgSize(url: string) {
	return new Promise((resolve, reject) => {
		var img = new Image();
		img.src = url;
	
		// Wait for the image to load
		img.onload = function() {
			resolve({
				width: img.naturalWidth,
				height: img.naturalHeight,
			});
		};	
	});
}

export function getOffsetTopBackTo(el: any, backTo: any) {
	let result = 0;
	let nextOffsetParent = el;
	while (el) {
		if (el === nextOffsetParent) {
			result += el.offsetTop;
			nextOffsetParent = el.offsetParent;
		}

		el = el.parentElement;
		if (el === backTo) {
			break;
		}
	}
	return result;
}